// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable guard-for-in */
import Modal from '../../components/Modal';
import { Events } from '../../utils/dom/html-events';
import Manipulator from '../../utils/dom/manipulator';
import Request, { ApiMode } from '../../utils/Request';
import { ClassNames } from '../../utils/dom/css-classes';
import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import { ModalPageLayout } from '../ModalPageLayout';
import { householdQuestionRenderers } from '../../pages/HouseholdAccounts/formQuestions/questionRenderers';

const SELECTOR_ADD_HOUSEHOLD_MEMBER_MODAL = '#p-household-accounts-add-member-page__modal';
const SELECTOR_HOUSEHOLD_ADD_MEMBERS_QUESTION_WRAPPER = '.p-household-accounts-add-member-page__questions';

const SELECTOR_ADD_HOUSEHOLD_MEMBER_MODAL_EXIT_BUTTON = '.js-household-add-member-modal-exit-button';

const SELECTOR_EXIT_HOUSEHOL_MEMBER_MODAL_EXIT_BUTTON = '.js-exit-household-member-modal-exit-btn';
const SELECTOR_ADD_HOUSEHOLD_MEMBER_MODAL_EXIT_CONFIRM_MODAL = '.js-exit-household-add-member-confirm';
const SELECTOR_ADD_HOUSEHOLD_MEMBER_MODAL_EXIT_CONFIRM_YES = '.js-exit-household-add-member-confirm-yes';
const SELECTOR_ADD_HOUSEHOLD_MEMBER_MODAL_EXIT_CONFIRM_NO = '.js-exit-household-add-member-confirm-no';

const SELECTOR_ADD_HOUSEHOLD_MEMBER_MODAL_ERROR_CONTAINER = '.js-household-accounts-add-member-page__error-container';

const SELECTOR_HOUSEHOLD_MEMBERS_SUMMARY_PAGE_WRAPPER = '.js-household-members-summary-page';
const SLECTOR_HOUSEHOLD_MEMBERS_WRAPPER = '.js-household-members-wrapper';
const SELECTOR_ADD_NEW_HOUSEHOLD_MEMBER_BUTTON = '.js-add-new-household-member-button';
const SELECTOR_HOUSEHOLD_MEMBER_FINAL_SUBMIT_BUTTON = '.js-final-household-members-submit-button';

const SELECTOR_HOUSEHOLD_MEMBERS_SUMMARY_PAGE_ERROR_CONTAINER = '.js-household-members-summary-page__error-container';

const SELECTOR_HOUSEHOLD_MEMBERS_SUCCESS_SCREEN = '.js-household-members-success-page';
const SELECTOR_SUCCESS_SCREEN_MEMBER_STATUS_WRAPPER = '.js-success-screen-member-status-wrapper';
const SELECTOR_SUCCESS_SCREEN_EXIT_BUTTON = '.js-success-page-submit-button';

const IS_LOCAL = false;
const EXIT_MODE_PAGE_CONTROLLED = 'page-controlled';

export const HOUSEHOLD_ADD_MEMBER_SUCCESS_EXIT = 'household-add-member:success-exit';

class HouseholdAddMember {
	constructor() {
		this._wrapper = SelectorEngine.findOne('.p-household-accounts-add-member-page');
		if (!this._wrapper) return;
		this.numberOfMembersAdded = 0;
		this._isInitialized = false;
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this._modalEl = SelectorEngine.findOne(SELECTOR_ADD_HOUSEHOLD_MEMBER_MODAL, this._wrapper);
		this.questions = SelectorEngine.findOne(SELECTOR_HOUSEHOLD_ADD_MEMBERS_QUESTION_WRAPPER, this._wrapper);
		this._modalInstance = new Modal(this._modalEl, {});
		this.isPageControlledExit = this._wrapper?.dataset.exitMode === EXIT_MODE_PAGE_CONTROLLED;
		this.sourcePageUrl = window.location.pathname;

		const exitConfirmModalHtml = SelectorEngine.findOne(
			SELECTOR_ADD_HOUSEHOLD_MEMBER_MODAL_EXIT_CONFIRM_MODAL,
			this._wrapper
		);

		this.exitConfirmModal = new Modal(exitConfirmModalHtml, { backdrop: 'static' });
		this.exitConfirmModalExitBtn = SelectorEngine.findOne(SELECTOR_EXIT_HOUSEHOL_MEMBER_MODAL_EXIT_BUTTON);
		this.exitConfirmYes = SelectorEngine.findOne(SELECTOR_ADD_HOUSEHOLD_MEMBER_MODAL_EXIT_CONFIRM_YES);
		this.exitConfirmNo = SelectorEngine.findOne(SELECTOR_ADD_HOUSEHOLD_MEMBER_MODAL_EXIT_CONFIRM_NO);

		// ----- Review Members Screen selectors -----
		this.householdMembersSummaryWrapper = SelectorEngine.findOne(SELECTOR_HOUSEHOLD_MEMBERS_SUMMARY_PAGE_WRAPPER);
		this.houseHoldMemberSummaryModal = new ModalPageLayout(this.householdMembersSummaryWrapper);
		this.addNewHouseholdMemberButton = SelectorEngine.findOne(
			SELECTOR_ADD_NEW_HOUSEHOLD_MEMBER_BUTTON,
			this.householdMembersSummaryWrapper
		);
		this.membersWrapper = SelectorEngine.findOne(
			SLECTOR_HOUSEHOLD_MEMBERS_WRAPPER,
			this.householdMembersSummaryWrapper
		);

		this._initialMembersHtml = this.membersWrapper?.innerHTML || '';

		this.finalSubmitBtn = SelectorEngine.findOne(
			SELECTOR_HOUSEHOLD_MEMBER_FINAL_SUBMIT_BUTTON,
			this.householdMembersSummaryWrapper
		);

		// ----- Success screen selectors -----
		this.householdMembersSuccessScreen = SelectorEngine.findOne(SELECTOR_HOUSEHOLD_MEMBERS_SUCCESS_SCREEN);
		this.householdSuccessScreenModal = new ModalPageLayout(this.householdMembersSuccessScreen);
		this.householdSuccessScreenMembersStatusWrapper = SelectorEngine.findOne(
			SELECTOR_SUCCESS_SCREEN_MEMBER_STATUS_WRAPPER,
			this.householdMembersSuccessScreen
		);
		this.successPageExitButton = SelectorEngine.findOne(
			SELECTOR_SUCCESS_SCREEN_EXIT_BUTTON,
			this.householdMembersSuccessScreen
		);

		if (this.successPageExitButton) {
			EventHandler.on(this.successPageExitButton, Events.Click, (event) => {
				const isPageControlled = this.isPageControlledExit;

				if (isPageControlled) {
					event.preventDefault();
					document.body.style.overflowY = 'auto';
					this.householdSuccessScreenModal.hideModal();
					this.houseHoldMemberSummaryModal.hideModal();
					this._modalInstance.hide();

					// ✅ Reset members state
					this.resetMembersState();

					document.dispatchEvent(new CustomEvent(HOUSEHOLD_ADD_MEMBER_SUCCESS_EXIT));
				}

				// Default behaviour → allow href redirect
			});
		}

		this.initFinalSubmitHandler();

		if (this.addNewHouseholdMemberButton) {
			EventHandler.on(this.addNewHouseholdMemberButton, Events.Click, () => {
				this.householdMembersSummaryWrapper.classList.add(ClassNames.Hidden);
				this.houseHoldMemberSummaryModal.hideModal();
				this._wrapper.classList.remove(ClassNames.Hidden);
				this._modalInstance.show();
				this.fetchHouseHoldAddMemberQuestions();
			});
		}

		this.addNewHouseholdMemberErrorContainer = SelectorEngine.findOne(
			SELECTOR_ADD_HOUSEHOLD_MEMBER_MODAL_ERROR_CONTAINER,
			this._wrapper
		);
		this.addNewHouseholdMemberErrorText = SelectorEngine.findOne(
			'.error-text',
			this.addNewHouseholdMemberErrorContainer
		);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this.addNewHouseholdMemberErrorContainer);

		this._closeErrorSnackBar.addEventListener(Events.Click, () => {
			this.addNewHouseholdMemberErrorContainer.classList.add(ClassNames.Hidden);
			this.resetAddMemberForm();
		});

		this.householdSummaryPageErrorContainer = SelectorEngine.findOne(
			SELECTOR_HOUSEHOLD_MEMBERS_SUMMARY_PAGE_ERROR_CONTAINER,
			this.householdMembersSummaryWrapper
		);
		this.householdSummaryPageErrorText = SelectorEngine.findOne('.error-text', this.householdSummaryPageErrorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this.householdSummaryPageErrorContainer);

		this._closeErrorSnackBar.addEventListener(Events.Click, () => {
			this.householdSummaryPageErrorContainer.classList.add(ClassNames.Hidden);
		});

		this.updateAddedMembersCount();

		this._isInitialized = true;
	}

	open() {
		if (!this._isInitialized) {
			// eslint-disable-next-line no-console
			console.warn('Component not initialized yet');
			return;
		}
		this.showModal();
		this._wrapper.classList.remove(ClassNames.Hidden);
		this.fetchHouseHoldAddMemberQuestions();
	}

	close() {
		if (!this._isInitialized) {
			// eslint-disable-next-line no-console
			console.warn('Component not initialized yet');
			return;
		}
		this.hideModal();
	}

	showModal() {
		if (this._modalInstance) {
			this._modalInstance.show();
		}
	}

	hideModal() {
		if (this._modalInstance) {
			this._modalInstance.hide();
		}
	}

	isReady() {
		return this._isInitialized;
	}

	updateAddedMembersCount() {
		this._memberCards = SelectorEngine.find('[data-member-id]', this.membersWrapper);

		// eslint-disable-next-line unicorn/prefer-ternary
		if (this._memberCards) {
			// eslint-disable-next-line unicorn/prefer-spread
			this.memberIds = Array.from(this._memberCards)
				// eslint-disable-next-line unicorn/prefer-dom-node-dataset, unicorn/prevent-abbreviations
				.map((el) => el.getAttribute('data-member-id'))
				.filter(Boolean);
		} else {
			this.memberIds = [];
		}

		this.numberOfMembersAdded = this.memberIds.length;
	}

	resetMembersState() {
		if (!this.membersWrapper) return;

		// Reset DOM
		this.membersWrapper.innerHTML = this._initialMembersHtml;

		// Reset state
		this.memberIds = [];
		this.numberOfMembersAdded = 0;
	}

	resetAddMemberForm() {
		if (this._stepsData?.length > 0) {
			this.initiateFormGenerator(this._stepsData);
		} else {
			this.fetchHouseHoldAddMemberQuestions();
		}

		this.addNewHouseholdMemberErrorContainer?.scrollIntoView({
			behavior: 'smooth',
			block: 'start'
		});
	}

	initEventHandlers() {
		if (!this.exitButton) return;

		EventHandler.on(this.exitButton, Events.Click, () => {
			this.exitConfirmModal.show();
		});

		if (this._confirmExitHandlersBound) return;
		this._confirmExitHandlersBound = true;

		EventHandler.on(this.exitConfirmModalExitBtn, Events.Click, () => {
			this.exitConfirmModal.hide();
		});

		EventHandler.on(this.exitConfirmNo, Events.Click, () => {
			this.exitConfirmModal.hide();
		});

		EventHandler.on(this.exitConfirmYes, Events.Click, (event) => {
			// Default behaviour → allow href redirect
			if (!this.isPageControlledExit) return;

			event.preventDefault();

			// Wait for confirm modal to fully hide
			EventHandler.one(
				this.exitConfirmModal._element,
				'hidden.lta.modal',
				() => {
					this._modalInstance.hide();
					this.resetMembersState();
				}
			);

			this.exitConfirmModal.hide();
		});
	}

	initiateFormGenerator(stepsData) {
		if (this.formGenerator) {
			this.formGenerator.unload();
			// eslint-disable-next-line unicorn/no-null
			this.formGenerator = null;
		}

		this.questions.innerHTML = '';

		this.formGenerator = new FormGenerator(this.questions, {
			questions: stepsData,
			totalSteps: 1,
			formType: FormTypes.SectionForm,
			isHideProgress: true,
			themeColor: 'color-lta-blue',
			hasSeparator: false,
			isExitButtonEnabled: true,
			exitButtonLabel: 'Close',
			exitButtonClasses: 'js-household-add-member-modal-exit-button',
			isbackButtonEnabled: false,
			submitButton: {
				title: 'Add to household',
				alwaysVisible: true
			},
			questionRenderers: householdQuestionRenderers
		});

		requestAnimationFrame(() => {
			this.exitButton = SelectorEngine.findOne(SELECTOR_ADD_HOUSEHOLD_MEMBER_MODAL_EXIT_BUTTON, this._wrapper);
			if (this.exitButton) {
				this.initEventHandlers();
			} else {
				// eslint-disable-next-line no-console
				console.warn('Exit button not found after FormGenerator render');
			}
		});

		this.formGenerator.onSubmit(async (answers) => {
			this.prepareRequestObject(answers);
			await this.addHouseHoldMenber(this.answerList);
		});
	}

	prepareRequestObject(stepsAnswers) {
		this.answerList = {};

		// eslint-disable-next-line unicorn/prevent-abbreviations
		const extractFields = (obj) => {
			for (const key in obj) {
				const item = obj[key];

				if (item && typeof item === 'object' && item.fieldName && item.value !== undefined) {
					this.answerList[item.fieldName] = item.value;
				}

				if (item && typeof item === 'object' && !Array.isArray(item)) {
					extractFields(item);
				}
			}
		};

		extractFields(stepsAnswers);
	}

	async fetchHouseHoldAddMemberQuestions() {
		startLoadingAnimation(true);
		try {
			const url = Manipulator.getDataAttribute(this._wrapper, 'household-add-member-form-steps-url');
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: { apiMode: ApiMode.LtaError }
				}
			);
			stopLoadingAnimation();
			const { Steps, errorMessage } = response;
			// eslint-disable-next-line unicorn/no-null
			if (Steps == null && errorMessage !== '') {
				this.showErrorContainer(errorMessage);
			} else {
				this.stepsData = Steps;
			}
		} catch (error) {
			stopLoadingAnimation();
			// eslint-disable-next-line no-console
			console.error('Error fetching steps:', error);
		}
	}

	async addHouseHoldMenber(requestObject) {
		const numberOfMembersAdded = this.numberOfMembersAdded;
		const finalPayload = {
			numberOfMembersAdded,
			...requestObject
		};
		startLoadingAnimation(true);
		try {
			const url = Manipulator.getDataAttribute(this._wrapper, 'household-save-member-url');
			const response = await Request.post(url, finalPayload, {
				local: IS_LOCAL,
				req: { apiMode: ApiMode.LtaError }
			});
			const { success, membersHtml, errorMessage } = response;
			stopLoadingAnimation();
			if (!success && errorMessage !== '') {
				this.showErrorContainer(errorMessage);
			} else {
				this.formGenerator.unload();
				this._modalInstance.hide();
				this._wrapper.classList.add('u-hidden');
				// TODO [HOUSEHOLD]: Discuss with Shivani and remove if not needed anymore.
				// document.body.style.overflowY = 'hidden';
				this.houseHoldMemberSummaryModal.showModal();
				// --- appending new data to existing data ---
				this.membersWrapper.insertAdjacentHTML('beforeend', membersHtml);
				this.updateAddedMembersCount();
			}
			// eslint-disable-next-line unicorn/consistent-destructuring
			if (response.error?.hasError) throw response.error;
		} catch (error) {
			stopLoadingAnimation();
			// eslint-disable-next-line no-console
			console.error('Error adding member:', error);
		}
	}

	initFinalSubmitHandler() {
		if (!this.finalSubmitBtn) return;
		EventHandler.on(this.finalSubmitBtn, Events.Click, async () => {
			try {
				if (this.memberIds.length === 0) {
					// eslint-disable-next-line no-console
					console.warn('No household members found to submit.');
					return;
				}

				const payload = {
					memberIds: this.memberIds,
					sourcePageUrl: this.sourcePageUrl
				};

				startLoadingAnimation(true);

				const url = Manipulator.getDataAttribute(this.membersWrapper, 'household-final-submit-url');
				const response = await Request.post(url, payload, {
					local: IS_LOCAL,
					req: { apiMode: ApiMode.LtaError }
				});

				stopLoadingAnimation();

				const { success, contentHtml, errorMessage } = response;

				if (!success && errorMessage !== '') {
					this.showErrorContainer(errorMessage);
				} else {
					this.houseHoldMemberSummaryModal.hideModal();
					this.householdMembersSuccessScreen.classList.remove(ClassNames.Hidden);
					this.householdSuccessScreenModal.showModal();
					this.householdSuccessScreenMembersStatusWrapper.innerHTML = contentHtml;
				}
			} catch (error) {
				stopLoadingAnimation();
				// eslint-disable-next-line no-console
				console.error('Error during final submit:', error);
			}
		});
	}

	showErrorContainer(message) {
		if (this.houseHoldMemberSummaryModal.isOpen()) {
			this.addNewHouseholdMemberErrorContainer.classList.remove(ClassNames.Hidden);
			this.addNewHouseholdMemberErrorText.innerHTML = message;

			this.addNewHouseholdMemberErrorContainer.scrollIntoView({
				behavior: 'smooth',
				block: 'center'
			});
		} else {
			this.householdSummaryPageErrorContainer.classList.remove(ClassNames.Hidden);
			this.householdSummaryPageErrorText.innerHTML = message;

			this.householdSummaryPageErrorContainer.scrollIntoView({
				behavior: 'smooth',
				block: 'center'
			});
		}
	}
}

export default HouseholdAddMember;
